import {Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {Config} from "../../../common/config";
import {ValidationService} from "../../../util/service/validation/validation-service";
import {Subscription} from "rxjs";
import {BaseComponent} from "../../base.component";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {DocumentUtil} from "../../../util/document.util";
import {Constant} from '../../../common/constant';

@Component({
  selector: 'app-frontend-button',
  standalone: false,
  templateUrl: './frontend-button.component.html',
  styleUrls: ['./frontend-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrontendButtonComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input()
  title?: string;
  @Input()
  required: boolean = false;
  @Input()
  disabled?: boolean = false;
  @Input()
  cards?: string;
  @Input()
  boxes?: string;
  @Input()
  class?: string;
  @Input()
  color: ThemePalette;
  @Input()
  endpoint?: string;
  @Input()
  hidden?: boolean = true;
  @Input()
  icon?: string;
  @Input()
  client?: string;
  @Input()
  validationRequired: boolean = false;
  @Input()
  src?: string;
  @Input()
  Image?: boolean = false;
  @Input()
  loading = false;
  @Output()
  onSubmit = new EventEmitter<void>();
  @Output() click = new EventEmitter<void>();
  private isValid: boolean = true;
  private subscription?: Subscription;

  constructor(injector: Injector, private validationService: ValidationService) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    DocumentUtil.setProperty('--button-text-color', Config.domain.Details.PrimaryTextColor);
    DocumentUtil.setProperty('--button-background-color', Config.domain.Details.PrimaryBackgroundColor);
    DocumentUtil.setProperty('--button-border-color', Config.domain.Details.PrimaryBorderColor);
    DocumentUtil.setProperty('--button-img-background-color', Config.domain.Details.AccentBackgroundColor);
    DocumentUtil.setProperty('--button-img-text-color', Config.domain.Details.AccentTextColor);
    DocumentUtil.setProperty('--button-img-border-color', Config.domain.Details.AccentBorderColor);
    if (this.endpoint && Config.permissions) {
      if (Config.permissions.some((permission: any) => {
        return `/${Constant.FOOD_SHOP}${this.endpoint}` === (permission.EndPoint ?? '');
      })) {
        this.hidden = false;
      }
    } else {
      this.hidden = false;
    }
    this.subscription = this.validationService.validationStatus$.subscribe(status => {
      this.isValid = status;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  handleClick() {
    if (this.disabled || this.loading) return;
    if (this.validationRequired) {
      this.validationService.resetValidationStatus();
      this.validationService.triggerValidation();
      setTimeout(() => {
        if (this.isValid) {
          this.onSubmit.emit();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant('FillRequiredFields'), false);
        }
      }, 100);
    }
  }
}
